import { MAGNOLIA_NEXT_API_URL, PAYMENT_URL } from "@/constants";

const fetchPayment = async () => {
  let pageJson;
  try {
    const fetchURL = `${MAGNOLIA_NEXT_API_URL}/${PAYMENT_URL}`;
    const response = await fetch(fetchURL);
    if (!response.ok) {
      pageJson = {};
    }
    const res = await response.json();
    [pageJson] = res.data.results;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error fetching payment data:", error);
    pageJson = {};
  }

  return pageJson;
};
export default fetchPayment;
